import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  makeStyles,
  Tooltip,
  CardHeader,
  Card,
} from "@material-ui/core";
import React, { useMemo } from "react";
import clsx from "clsx";
import * as _ from "lodash";

import AddIcon from "@material-ui/icons/AddOutlined";

import { FunctionDefinition } from "./types";
import { FunctionRow } from "./FunctionRow";

interface FunctionsListViewProps {
  onNewFunction: () => void;
  onSelectFunction: (id: string) => void;
  functionDefs: FunctionDefinition[];
}

const useStyles = makeStyles((theme) => ({
  cardHeader: {
    display: "flex",
    alignItems: "center",
  },
  cardTitle: {
    paddingRight: 15,
  },
  tableRow: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
  },
  tableCell: {
    paddingTop: 6,
    paddingBottom: 6,
    lineHeight: "35px",
  },
  tableCellEllipsis: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  tableCellSource: {
    maxWidth: 150,
  },
  tableCellFunctionName: {
    maxWidth: 250,
  },
  icon: {
    display: "flex",
    marginRight: theme.spacing(1),
    fill: "#617984",
  },
  flexGrow: {
    flexGrow: 1,
  },
  card: {
    overflowX: "auto",
  },
  actions: {
    justifyContent: "flex-end",
  },
}));

export const FunctionsListView: React.FC<FunctionsListViewProps> = ({
  onNewFunction,
  onSelectFunction,
  functionDefs,
}) => {
  const classes = useStyles();
  const sortedFunctionDefs = useMemo(
    () =>
      _.sortBy(functionDefs, (functionDef) => functionDef.name.toLowerCase()),
    [functionDefs]
  );
  const rows = sortedFunctionDefs.map((functionDef) => (
    <FunctionRow
      key={functionDef.id}
      onSelectFunction={() => onSelectFunction(functionDef.id)}
      functionDef={functionDef}
    />
  ));
  return (
    <Card className={clsx(classes.card, "fs-exclude")}>
      <CardHeader
        title={
          <div className={clsx(classes.cardHeader)}>
            <div className={clsx(classes.cardTitle)}>Function Definitions</div>
            <div className={clsx(classes.flexGrow)} />
            <Button
              className="h-full"
              color="primary"
              onClick={onNewFunction}
              variant="contained"
            >
              <AddIcon className={classes.icon} />
              Create New Function
            </Button>
          </div>
        }
      />
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Function Source</TableCell>
            <TableCell>Type</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{rows}</TableBody>
      </Table>
    </Card>
  );
};
